import { render, staticRenderFns } from "./announcementModal.vue?vue&type=template&id=5dd00590&scoped=true&"
import script from "./announcementModal.vue?vue&type=script&lang=js&"
export * from "./announcementModal.vue?vue&type=script&lang=js&"
import style0 from "./announcementModal.vue?vue&type=style&index=0&id=5dd00590&lang=scss&scoped=true&"
import style1 from "./announcementModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd00590",
  null
  
)

export default component.exports